import type {
  AppNotificationActionLabel,
  AppNotificationConfig,
  AppNotificationSetting,
  NotificationSurface,
} from 'src/constants/dataTypes/appsTypes';

export type NotificationSettingDraft = {
  label: string;
  surfaces: NotificationSurface[];
};

export const NOTIFICATION_SURFACES: {
  id: NotificationSurface;
  label: string;
  description: string;
}[] = [
  { id: 'product', label: 'Product', description: 'Notification center.' },
  {
    id: 'email',
    label: 'Email',
    description: 'Email notifications sent to the internal user.',
  },
];

/**
 * The setting a modal draft saves as. New settings carry an empty id so the
 * backend stamps a stable UUID; defaults are on for each supported surface.
 */
export const toNotificationSetting = (
  { label, surfaces }: NotificationSettingDraft,
  id = '',
): AppNotificationSetting => ({
  id,
  label,
  surfaces,
  default: {
    product: surfaces.includes('product'),
    email: surfaces.includes('email'),
  },
});

/**
 * The notification config to write. The action label is kept only when all
 * three parts are filled, so a partial or whitespace-only "[verb] [noun]" is
 * never stored.
 */
export const toNotificationConfigPayload = ({
  notifications,
  actionLabel,
}: {
  notifications?: AppNotificationSetting[];
  actionLabel?: Partial<AppNotificationActionLabel>;
}): AppNotificationConfig => {
  const verb = actionLabel?.verb?.trim();
  const singularNoun = actionLabel?.singularNoun?.trim();
  const pluralNoun = actionLabel?.pluralNoun?.trim();
  return {
    notifications: notifications ?? [],
    ...(verb && singularNoun && pluralNoun
      ? { actionLabel: { verb, singularNoun, pluralNoun } }
      : {}),
  };
};
